module.exports = __webpack_public_path__ + "e1178856d7fef5a8dcd53af9f9836ab7.svg";